/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { UpgradeUploadEntryModule } from '../upload-entry/upgrade-upload-entry.modules';
import { UpgradeChooseModeComponent } from './upgrade-choose-mode.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        UpgradeUploadEntryModule,
    ],
    declarations: [
        UpgradeChooseModeComponent,
    ],
    exports: [UpgradeChooseModeComponent],
})

export class UpgradeChooseModeModule { }
